import {
  BRIDGE_METHODS,
  BRIDGE_NAME,
} from "./bridgeConstants";
import { getUrlConfig } from "./deeplinkUrlConfig";
import ChatBotMeta from "../utils/singletonChatBotMeta";

export const TOKEN_DELIMITER = "###";
export const TXN_HISTORY = "txnHistory";

export const IRIS_TOKEN = "iris_token";

export const validateAndGetToken = authToken => {
  try {
    if (!authToken) {
      return null;
    }

    var tokenResponse = authToken.split(TOKEN_DELIMITER);
    var currentTimeStamp = Date.now();
    var expiry =
      new Date(parseInt(tokenResponse[1])) * 1000;

    var timeDifference = currentTimeStamp - expiry;

    return timeDifference <= -600000
      ? {
          //Need this to add buffer time before expiry
          token: tokenResponse[0],
          userId: tokenResponse[2],
          name: tokenResponse[3],
          language: tokenResponse[4],
        }
      : null;
  } catch (err) {
    console.log(err);
    return null;
  }
};
export const generateToken = () => {
  try {
    var context = window.btoa(
      JSON.stringify({
        bridgeType: BRIDGE_METHODS.GENERATE_TOKEN,
      })
    );
    var data = "";
    Freshbot.getToken(context, data, BRIDGE_NAME);
  } catch (err) {
    console.log(err);
  }
};

export const getTokenStamped = function (
  rawToken,
  expiresAt,
  userId,
  userName,
  language
) {
  return rawToken.concat(
    TOKEN_DELIMITER,
    expiresAt,
    TOKEN_DELIMITER,
    userId,
    TOKEN_DELIMITER,
    userName,
    TOKEN_DELIMITER,
    language
  );
};

/**
 * @desc    Save the token inside the sdk.
 *
 * @param token     {String}    The token that ought to be saved
 */
export const saveToken = token => {
  try {
    NativeStore.setString(IRIS_TOKEN, token);
  } catch (err) {
    console.log(err);
  }
};

export const getMobileOperatingSystem = () => {
  if (typeof window === "undefined") {
    return null;
  }
  var userAgent =
    navigator.userAgent ||
    navigator.vendor ||
    navigator.standalone ||
    window.opera;
  if (/android/i.test(userAgent)) {
    return "ANDROID";
  }
  if (
    /iPad|iPhone|iPod|safari/.test(userAgent) &&
    !window.MSStream
  ) {
    return "IOS";
  }
};

export const isMobile = () => {
  return ["ANDROID", "IOS"].includes(
    getMobileOperatingSystem()
  );
};
export const isWeb = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return !isMobile();
};
/**
 * @desc    To fetch token from the data store of Native layer.
 *
 *          The callback of it will define what should be the next course of action.
 *          If token is null of expired, generate token flow will be followed.
 */
export const fetchToken = function () {
  try {
    var context = btoa(
      JSON.stringify({
        bridgeType: BRIDGE_METHODS.FETCH_TOKEN,
      })
    );
    var data = btoa(
      JSON.stringify({
        key: IRIS_TOKEN,
      })
    );
    NativeStore.getString(context, data, BRIDGE_NAME);
  } catch (err) {
    console.log(err);
  }
};
export const isMobileBridgePresent = () => {
  return (
    !!window?.JsHandler || !!window?.webkit?.messageHandlers
  );
};
export const navigateToURL = ctaKey => {
  const config = getUrlConfig(ChatBotMeta.get())?.[ctaKey];
  const OS = getMobileOperatingSystem();
  if (config) {
    // var screenName = config["screenName"];
    // var androidFallbackUrl = config["androidFallbackUrl"];

    const { deepLink } = config;
    if (
      ctaKey === "CHATBOT" &&
      ["ANDROID", "IOS"].includes(OS)
    ) {
      window.open(deepLink);
      return;
    }

    if (OS.toUpperCase() === "ANDROID") {
      try {
        window.JsHandler.navigateDeeplink(deepLink, false);
      } catch (e) {
        window.open(config["webURL"]);
      }
    } else if (OS.toUpperCase() === "IOS") {
      try {
        window.webkit.messageHandlers.navigateTo.postMessage(
          {
            data: btoa(JSON.stringify({ dl: deepLink })),
          }
        );
      } catch (err) {
        console.log("Error opening app screen: ", err);
      }
    } else {
      window.open(config["webURL"]);
    }
  }
};

export const openURL = (url, title = "") => {
  try {
    var data = btoa(
      JSON.stringify({
        url,
        title: title || "Ticket Details",
        isExternal: true,
      })
    );
    Freshbot.openURL(data);
  } catch (err) {
    console.log(err);
  }
};

export const trackEvent = selection => {
  try {
    var data = window.btoa(
      JSON.stringify({
        t0: selection,
        t1: window?.location?.pathname,
      })
    );
    Freshbot.logEvent("FAQ_FEEDBACK_CLICK", "HELP", data);
  } catch (err) {
    console.log(err);
  }
};
